export default "__VITE_ASSET__2dc602f4__"